module.exports = __webpack_public_path__ + "img/Offers.2b72de38.svg";